// glyphs the refreshed panels need that layout/icons does not ship

export function CloudUploadIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth={1.3} strokeLinecap="round" strokeLinejoin="round" aria-hidden={true}>
      <path d="M4.2 12.4A3.1 3.1 0 0 1 4.6 6.3a4.3 4.3 0 0 1 8.1 1.1 2.7 2.7 0 0 1-.6 5.3" />
      <path d="M8 8.2v6M5.9 10.3 8 8.2l2.1 2.1" />
    </svg>
  );
}

export function KebabIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden={true}>
      <circle cx="8" cy="3.2" r="1.3" /><circle cx="8" cy="8" r="1.3" /><circle cx="8" cy="12.8" r="1.3" />
    </svg>
  );
}

export function ClipboardCountIcon({ size = 14 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth={1.1} strokeLinecap="round" strokeLinejoin="round" aria-hidden={true}>
      <path d="M5.2 2.4H4a1.2 1.2 0 0 0-1.2 1.2v7.2A1.2 1.2 0 0 0 4 12h6a1.2 1.2 0 0 0 1.2-1.2V3.6A1.2 1.2 0 0 0 10 2.4H8.8" />
      <rect x="5.2" y="1.4" width="3.6" height="2" rx="0.7" />
    </svg>
  );
}

export function PhotoPlaceholderIcon({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden={true}>
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <circle cx="8.8" cy="8.8" r="1.6" />
      <path d="m3.6 17.4 4.8-4.3 3.2 2.8 3.1-2.8 5.7 5.1" />
    </svg>
  );
}

// filled brand mark - layout/icons only ships stroke glyphs
export function YoutubeGlyph({ size = 13 }: { size?: number }) {
  return (
    <svg width={size} height={size * 0.7} viewBox="0 0 24 17" fill="currentColor" fillRule="evenodd" clipRule="evenodd" aria-hidden={true}>
      <path d="M23.5 3.2A3 3 0 0 0 21.4 1C19.5.5 12 .5 12 .5S4.5.5 2.6 1A3 3 0 0 0 .5 3.2 31 31 0 0 0 0 8.5a31 31 0 0 0 .5 5.3A3 3 0 0 0 2.6 16c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.2 31 31 0 0 0 .5-5.3 31 31 0 0 0-.5-5.3zM9.6 12.1V4.9l6.2 3.6z" />
    </svg>
  );
}

export function PlayTriangleIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden={true}>
      <path d="M5.4 3.2 12.4 8l-7 4.8z" />
    </svg>
  );
}
